// extracted by mini-css-extract-plugin
export default {"container":"Diseases_container__soOAG","heading":"Diseases_heading__Q2Q5D","cards":"Diseases_cards__Rbk29","card":"Diseases_card__7KDaW","cardcontain":"Diseases_cardcontain__bjOMU"};